module.exports = __webpack_public_path__ + "img/exchange-funds-fill.368b517d.svg";